<section>
  <div class="success-container">
    <div class="success-text">
      <h1>Session Expired Warning</h1>
      <h2>
        Your session is about to expire due to inactivity! For security reasons,
        you will be logged off in <b>{{ counter$ | async }}</b> seconds.
      </h2>
    </div>
  </div>
  <div class="mt-4 flex justify-center">
    <button class="btn-primary" (click)="closeDialog(true)" cdkFocusInitial>
      Stay Signed In
    </button>
  </div>
</section>
